module.exports = __webpack_public_path__ + "static/logoBrown-42b2bae45fdb0f8d1479ba18b559ca0b.svg";